import React from "react";
import { AdyenDrawer } from "./AdyenDrawer";
import { GoogleAnalyticsDrawer } from "./GoogleAnalyticsDrawer";

import { GoogleMapsDrawer } from "./GoogleMapsDrawer";
import { GoogleTagManagerDrawer } from "./GoogleTagManagerDrawer";
import MottuDrawer from "./MottuDrawer";
import IFoodDrawer from "./IFoodDrawer";
import FoodyDeliveryDrawer from "./FoodyDeliveryDrawer";
import { OlgaDrawer } from "./OlgaDrawer";
import { PagarMeDrawer } from "./PagarMeDrawer";
import { SafraPayDrawer } from "./SafraPayDrawer";
import { ClearSaleDrawer } from "./ClearSaleDrawer";
import CatalogIFoodDrawer from "./CatalogIFoodDrawer";
import EcleticaDrawer from "./EcleticaDrawer";
import NetLogicDrawer from "./NetLogicDrawer";
import OrdaticDrawer from "./OrdaticDrawer/OrdaticDrawer";
import TotvsDrawer from "./TotvsDrawer";
import MenewDrawer from "./MenewDrawer";
import EasyassistDrawer from "./EasyassistDrawer";
import TeknisaDrawer from "./TeknisaDrawer";
import SaiposDrawer from "./SaiposDrawer";
import AtenaAIDrawer from "./AtenaAIDrawer/AtenaAIDrawer";
import NewChoiceDrawer from "./NewChoiceDrawer";
import TwilioDrawer from "./TwilioDrawer";
import BeeDeliveryDrawer from "./BeeDeliveryDrawer";
import { WooviDrawer } from "./WooviDrawer";
import SodeDrawer from "./SodeDrawer";
import CatalogNetLogicDrawer from "./CatalogNetLogicDrawer";
import EyeMobileDrawer from "./EyeMobileDrawer";
import BlingDrawer from "./BlingDrawer/BlingDrawer";
import GooglePayDrawer from "./GooglePayDrawer";
import ApplePayDrawer from "./ApplePayDrawer";
import { FalaeDrawer } from "./FalaeDrawer";


export const DrawerTypes = {
  GOOGLE_MAPS: "GOOGLE_MAPS",
  GOOGLE_MAPS_HOLDING: "GOOGLE_MAPS_HOLDING",
  GOOGLE_ANALYTICS: "GOOGLE_ANALYTICS",
  GOOGLE_TAG_MANAGER: "GOOGLE_TAG_MANAGER",
  GOOGLE_PAY: "GOOGLE_PAY",
  APPLE_PAY: "APPLE_PAY",
  HYPERLOCAL: "HYPERLOCAL",
  PAGARME: "PAGARME",
  SAFRAPAY: "SAFRAPAY",
  ADYEN: "ADYEN",
  OLGA: "OLGA",
  MOTTU: "MOTTU",
  IFOOD: "IFOOD",
  FOODY_DELIVERY: "FOODY_DELIVERY",
  BEE_DELIVERY: "BEE_DELIVERY",
  SODE: "SODE",
  CATALOG_IFOOD: "CATALOG_IFOOD",
  CATALOG_NETLOGIC: "CATALOG_NETLOGIC",
  ECLETICA: "ECLETICA",
  NETLOGIC: "NETLOGIC",
  ORDATIC: "ORDATIC",
  CLEARSALE: "CLEARSALE",
  TOTVS: "TOTVS",
  MENEW: "MENEW",
  EASYASSIST: "EASYASSIST",
  TEKNISA: "TEKNISA",
  SAIPOS: "SAIPOS",
  ATENAAI: "ATENAAI",
  NEW_CHOICE: "NEW_CHOICE",
  EYEMOBILE: "EYEMOBILE",
  BLING: "BLING",
  TWILIO: 'TWILIO',
  WOOVI: "WOOVI",
  FALAE: "FALAE",
};

export class IntegrationDrawer extends React.Component {
  state = {
    data: null,
  };

  onClose() {
    const { onClose } = this.props;
    this.setState({ data: null }, onClose);
  }

  render() {
    const { visible, integration, onSave, onClose } = this.props;

    switch (integration) {
      case DrawerTypes.OLGA:
        return (
          <OlgaDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.GOOGLE_MAPS:
        return (
          <GoogleMapsDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case DrawerTypes.GOOGLE_MAPS_HOLDING:
        return (
          <GoogleMapsDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
            holding
          />
        );
      case DrawerTypes.GOOGLE_TAG_MANAGER:
        return (
          <GoogleTagManagerDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case DrawerTypes.GOOGLE_ANALYTICS:
        return (
          <GoogleAnalyticsDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case DrawerTypes.GOOGLE_PAY:
        return (
          <GooglePayDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case DrawerTypes.APPLE_PAY:
        return (
          <ApplePayDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case DrawerTypes.PAGARME:
        return (
          <PagarMeDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.ADYEN:
        return (
          <AdyenDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.SAFRAPAY:
        return (
          <SafraPayDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.CLEARSALE:
        return (
          <ClearSaleDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.MOTTU:
        return (
          <MottuDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.IFOOD:
        return (
          <IFoodDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.FOODY_DELIVERY:
        return (
          <FoodyDeliveryDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );

      case DrawerTypes.BEE_DELIVERY:
        return (
          <BeeDeliveryDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );

      case DrawerTypes.SODE:
        return (
          <SodeDrawer visible={visible} onSave={onSave} onClose={onClose} />
        )
      case DrawerTypes.CATALOG_IFOOD:
        return (
          <CatalogIFoodDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case DrawerTypes.CATALOG_NETLOGIC:
        return (
          <CatalogNetLogicDrawer
            visible={visible}
            onSave={onSave}
            onClose={onClose}
          />
        );
      case DrawerTypes.ECLETICA:
        return (
          <EcleticaDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.NETLOGIC:
        return (
          <NetLogicDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.ORDATIC:
        return (
          <OrdaticDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.TOTVS:
        return (
          <TotvsDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.MENEW:
        return (
          <MenewDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.EASYASSIST:
        return (
          <EasyassistDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.TEKNISA:
        return (
          <TeknisaDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.SAIPOS:
        return (
          <SaiposDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.ATENAAI:
        return (
          <AtenaAIDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.NEW_CHOICE:
        return (
          <NewChoiceDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.EYEMOBILE:
        return (
          <EyeMobileDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.BLING:
        return (
          <BlingDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.TWILIO:
        return (
          <TwilioDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.WOOVI:
        return (
          <WooviDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      case DrawerTypes.FALAE:
        return (
          <FalaeDrawer visible={visible} onSave={onSave} onClose={onClose} />
        );
      default:
        return null;
    }
  }
}
